// ======================================================================
// File Name       : ContentVideoList
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Table } from 'react-bootstrap';
import TableHead, { setSortState } from '../../components/TableHead';
import { DATA_AFFIILIATION_TYPE_TEXT } from '../../constants/ContentConstant';
import * as ICON from '../../constants/IconConstants';
import { SELECT_BOX_DATA } from '../../constants/SelectBoxData';
import VideoImage from '../../images/icon/video.png';
import { getItemBoxName, parseDateForDetail } from '../../utils/index';
import CustomLink from '../button/CustomLink';
import { CONTENT_VIDEO_DETAIL } from '../../constants/PathConstants';
import { Col } from 'react-bootstrap';
import PaginationCustom from '../Pagination';

const ContentVideoList = ({
  videoInfo,
  handleSortState,
  contentSearchInfo,
  handleMouseEnter,
  handleMouseLeave,
  recordNum,
  startPosition,
  getStartEndData,
}) => {
  const thead = [
    { title: 'コンテンツ識別ID', sortBy: 0},
    { title: 'コンテンツ名', sortBy: 1 , width:'30%'},
    { title: '外部', sortBy: 2, width:'5%'},
    { title: '登録日時', sortBy: 8},
    { title: '登録者', sortBy: null}, // Step 9.0.0
    { title: '変換ステータス', sortBy: 3},
    { title: '操作', sortBy: null, width:'100'},
  ];
  let data = thead;
  if (contentSearchInfo) {
    const sortBy = contentSearchInfo.videoSortType;
    const sortState = contentSearchInfo.ascendingDescendingSort;
    data = setSortState(thead, sortBy, sortState);
  }
  const objectStyle = { 'background-color': 'gray' };
  const videoList =
    videoInfo.contentList &&
    videoInfo.contentList.map((video, index) => {
      const link = CONTENT_VIDEO_DETAIL.replace(':id', video.contentSecernId);
      return (
        <tr key={index} onMouseEnter={() => handleMouseEnter(index)} onMouseLeave={() => handleMouseLeave()}>
          <td>
            <div> {video.contentSecernId} </div>
          </td>
          <td>{video.contentName}</td>
          <td>{getItemBoxName(DATA_AFFIILIATION_TYPE_TEXT, video.dataAffiliationType)}</td>
          <td>{parseDateForDetail(video.createdAt)}</td>
          {/* Step 9.0.0 START */}
          <td>{video.createdUserName}</td>
          {/* Step 9.0.0 END */}
          <td>{getItemBoxName(SELECT_BOX_DATA.VIDEO_STATUS, video.videoStatus)}</td>
          <td className="text-center">
            <CustomLink
              className="margin-right-7 link-detail-edit"
              to={link}
              text="詳細"
            />
          </td>
        </tr>
      );
    });

  return (
    <div>
      <Table striped hover>
        <thead>
          <TableHead data={data} handleSortState={handleSortState} />
        </thead>
        <tbody>{videoList}</tbody>
      </Table>
      <Col sm={12} className="d-flex justify-content-center">
        <PaginationCustom
          recordNum={recordNum}
          handlePageSelect={getStartEndData}
          startPosition={startPosition}
        />
      </Col>
    </div>
  );
};

export default ContentVideoList;
